module.exports = __webpack_public_path__ + "img/tani-logo.2e92ea60.svg";